import PoweredBy from 'components/PoweredBy';
import UserWidget from 'components/UserWidget';

import * as Styled from './Header.styles';

const Header = () => {
  return (
    <Styled.Header>
      <PoweredBy />
      <UserWidget />
    </Styled.Header>
  );
};

export default Header;
